export const KIT_ID = 'kit-id';
